import React from "react";

import AuresKonnectSection from "../sections/AuresKonnectSection";
import SynapsySection from "../sections/SynapsySection";
import ZerosixSection from "../sections/ZerosixSection";
import { FidelityFormApi } from "../useFidelityForm";
import { CESAR_LOYALTY } from "@constants/index";

type Props = {
    form: FidelityFormApi;
    fidelityChoiceIndex: number;
    isFidelityNumberInValid: boolean;
    setIsEdited: (v: boolean) => void;
};

export function FidelityProviderSection({
    form,
    fidelityChoiceIndex,
    isFidelityNumberInValid,
    setIsEdited,
}: Props) {
    if (fidelityChoiceIndex === CESAR_LOYALTY) {
        return (
            <AuresKonnectSection
                form={form}
                isFidelityNumberInValid={isFidelityNumberInValid}
                setIsEdited={setIsEdited}
            />
        );
    }
    if (fidelityChoiceIndex === 2) {
        return <SynapsySection form={form} setIsEdited={setIsEdited} />;
    }
    if (fidelityChoiceIndex === 3) {
        return <ZerosixSection form={form} setIsEdited={setIsEdited} />;
    }
    return null;
}
